import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_4'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-64),
        y: convertToPercentageY(133 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(23),
        y: convertToPercentageY(101 + yOffset),
        duration: 100,
      },
      {
        x: convertToPercentageX(83),
        y: convertToPercentageY(148 + yOffset),
        duration: 100,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_2_1'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(704),
        y: convertToPercentageY(109 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
        },
      },
      {
        x: convertToPercentageX(640),
        y: convertToPercentageY(90 + yOffset),
        duration: 100,
      },
      {
        x: convertToPercentageX(544),
        y: convertToPercentageY(148 + yOffset),
        duration: 100,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    landscape: {
      scaleCoeff: {
        scale: 1.6,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(-8),
        y: convertToPercentageY(-217),
        scale: 0.68,
      },
      {
        wait: 370,
      },
      {
        alpha: 1,
        callback: () => {
          G.sfx.corruption.play();
        },
      },
      {
        x: convertToPercentageX(747),
        y: convertToPercentageY(1162),
        duration: 150,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    landscape: {
      scaleCoeff: {
        scale: 1.6,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(-71),
        y: convertToPercentageY(-39),
        scale: 0.37,
      },
      {
        wait: 370,
      },
      {
        alpha: 1,
      },
      {
        x: convertToPercentageX(646),
        y: convertToPercentageY(1333),
        duration: 365,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    landscape: {
      scaleCoeff: {
        scale: 1.6,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(102),
        y: convertToPercentageY(-188),
        scale: 0.67,
      },
      {
        wait: 535,
      },
      {
        alpha: 1,
      },
      {
        x: convertToPercentageX(826),
        y: convertToPercentageY(1170),
        duration: 150,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    landscape: {
      scaleCoeff: {
        scale: 1.6,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(265),
        y: convertToPercentageY(-141),
        scale: 0.9,
      },
      {
        wait: 700,
      },
      {
        alpha: 1,
      },
      {
        x: convertToPercentageX(797),
        y: convertToPercentageY(769),
        duration: 250,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    landscape: {
      scaleCoeff: {
        scale: 1.6,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(-254),
        y: convertToPercentageY(-312),
        scale: 4,
      },
      {
        wait: 770,
      },
      {
        alpha: 1,
      },
      {
        x: convertToPercentageX(336.5),
        y: convertToPercentageY(663),
        duration: 200,
      },
    ],
  },
];
